import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Context } from 'src/app/shared/models/context';
import { Message } from 'src/app/shared/models/domain';
import { ExitInterview, Separation } from 'src/app/shared/models/separation';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { SeparationService } from 'src/app/shared/services/separation.service';
@Component({
  selector: 'app-exit-interview',
  templateUrl: './exit-interview.component.html',
  styleUrls: ['./exit-interview.component.scss']
})
export class ExitInterviewComponent implements OnInit {
  @Input() separation: Separation;
  @Input() context: Context;
  @Input() separationId: number;

  public exitInterviews: ExitInterview[] = [];
  public exitInterview: ExitInterview;
  public exitInterviewForm: FormGroup;
  public submitted: boolean = false;
  private modified: boolean = false;
  public selectedexitInterview: any;

  constructor(
    private separationService: SeparationService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private authService: AuthService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    this.context = this.authService.getContextData();
    this.setExitForm(this.exitInterview);
    this.getExitInterview();
  }

  public getExitInterview(){
    if (this.separationId) {
      this.separationService.getExitInterviews(this.separationId).subscribe(exitInterviews => {
        if (exitInterviews.length) {
          this.selectedexitInterview = exitInterviews[0];
          this.exitInterviewForm.patchValue(exitInterviews[0]); 
        }
      });
    }
  }

  public setExitForm(exitInterview?: ExitInterview) {
    if (!exitInterview)
      exitInterview = {
        id: null,
        feedback: null,
        rating: null,
        email: null,
        contact: null,
        suggestions: null,
        submittedAt: null,
        separationId: this.separationId,
        disabled: false
      } as ExitInterview;
    this.exitInterviewForm = this.fb.group({
      id: this.fb.control(exitInterview.id, []),
      feedback: this.fb.control(exitInterview.feedback, [Validators.required]),
      rating: this.fb.control(exitInterview.rating, [Validators.required]),
      email: this.fb.control(exitInterview.email, [Validators.required]),
      contact: this.fb.control(exitInterview.contact, [Validators.required]),
      suggestions: this.fb.control(exitInterview.suggestions, [Validators.required]),
      submittedAt: this.fb.control(this.datePipe.transform(new Date(), 'yyyy-MM-dd')),
      separationId: this.fb.control(exitInterview.separationId, [Validators.required]),
      disabled: this.fb.control(exitInterview.disabled, []),
    });
    this.exitInterviewForm.valueChanges.subscribe(value => this.modified = true);
  }

  get s() {
    return this.exitInterviewForm.controls;
  }

  public saveExitInterview() {
    console.log("Form",this.exitInterviewForm)
    this.submitted = true;
    this.exitInterviewForm.markAllAsTouched();
    if (this.exitInterviewForm.valid) {
      const exitInterview = this.exitInterviewForm.value as ExitInterview;
      this.separationService.createExitInterview(exitInterview).subscribe({
        next: (response: Message) => {
          if (!response.failed) {
            this.commonService.setToastr(200, `Exit Interview has been created successfully!`);
            this.getExitInterview();
          } else {
            this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
          }
        },
        error: (error: HttpErrorResponse) => {
          this.commonService.setToastr(500, error?.error?.name || error.error);
        },
      });
    }
  }
}



